import FFMSummary from './FFMSummary'

export default FFMSummary
